import React from "react";
import cn from "classnames";
import * as styles from "./styles.module.scss";

/** ============================================================================
 * @component
 * Prodivdes global grid layout
 */

const Grid = ({ children, className, narrowContent }) => (
  <div className={cn(styles.grid, className)}>
    {narrowContent ? (
      <div className={cn(styles.content, { [styles.narrow]: narrowContent })}>
        {children}
      </div>
    ) : (
      <>{children}</>
    )}
  </div>
);
export default Grid;
